module.exports = __webpack_public_path__ + "img/brooke-cagle-LCcFI_26diA-unsplash.43830500.png";